import universalTracker from './universal'
import ga4Tracker from './ga4'
import gtmTracker from './gtm'

export default function(config) {
    switch (config.script_type) {
        case 'ga':
            switch (config.version) {
                case 'universal':
                    return universalTracker
                case 'ga4':
                    return ga4Tracker
                default:
                    return
            }
        case 'gtag':
            return gtmTracker
        default:
            return
    }
}
